module.exports = __webpack_public_path__ + "static/media/become-nanny-bg.c205fff9.jpg";